import api from "../services/api"
import slugify from 'react-slugify';

export async function getUser() {
    return await api.get("/authentication/me/?expand=company")
}

export function loginUser(username, password) {
    return api.post('/get-token/', { username, password })
}

export function listHardwareModels(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    return api.get("/bwise-hardware/hardware-models/", { params: filters })
}

export function listHardwares(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    return api.get("/bwise-hardware/hardware/", { params: filters })
}

export function listLicenses(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    Object.keys(filters).forEach((k) => {
        if (filters[k] === null || filters[k] === "") {
            delete filters[k]
        }
    });
    return api.get("/bwise-license/licenses/", { params: filters })
}

export function listLicenseLinks(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    Object.keys(filters).forEach((k) => {
        if (filters[k] === null || filters[k] === "") {
            delete filters[k]
        }
    });
    return api.get("/bwise-license/license-links/", { params: filters })
}

export function listLicenseTypes(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    return api.get("/bwise-license/license-types/", { params: filters })
}

export function getLicenseType(id, filters = {}) {
    return api.get(`/bwise-license/license-types/${id}/`, { params: filters })
}

export function editLicenseType(id, data) {
    const { name, description, durationValue, durationUnit, types, config } = data
    var duration = null

    var slug_name = slugify(name)


    if (durationUnit !== "lifetime") {
        const durationToSecondsMap = {
            days: 86400,
            months: 2629800,
            years: 31557600
        }
        var totalSeconds = durationValue * durationToSecondsMap[durationUnit]

        duration = {
            seconds: totalSeconds
        }
    }

    if (!types.includes("historian")) {
        config["historian"] = {
            max_tags: 0
        }
    }

    if (!types.includes("pid")) {
        config["pid"] = {
            max_control_loops: 0
        }
    }
    console.log({
        name,
        slug_name,
        description,
        duration,
        types,
        config
    })
    return api.put(`/bwise-license/license-types/${id}/`, {
        name,
        slug_name,
        description,
        duration,
        types,
        config
    })
}

export function deleteLicenseType(id) {
    return api.delete(`/bwise-license/license-types/${id}/`)
}

export function listCompanies(page, pageSize, filters = {}) {
    filters["page"] = page
    filters["page_size"] = pageSize
    return api.get("/authentication/companies/", { params: filters })
}

export function addHardwareModel(
    manufacturer,
    model,
    cpu_model,
    cpu_arch,
    cpu_frequency_ghz,
    cpu_cores,
    ram_size_gb,
    disk_size_gb
) {
    return api.post("/bwise-hardware/hardware-models/", {
        manufacturer,
        model,
        cpu_model,
        cpu_arch,
        cpu_frequency_ghz,
        cpu_cores,
        ram_size_gb,
        disk_size_gb
    })
}

export function addHardware(
    company,
    hardware_model,
    hardware_key,
    name,
    description,
) {
    return api.post("/bwise-hardware/hardware/", {
        company,
        hardware_model,
        hardware_key,
        name,
        description,
    })
}
export function getAllCompanyValue() {
    return api.get("/authentication/companies/?page_size=1000")
}

export function getAllHardwareModels() {
    return api.get("/bwise-hardware/hardware-models/")
}

export function getAllHardware(filters = {}) {
    return api.get("/bwise-hardware/hardware/", { params: filters })

}

export function getHardware(id) {
    return api.get(`/bwise-hardware/hardware/${id}/?expand=company&expand=hardware_model`)
}

export function deleteHardwareModel(id) {
    return api.delete(`/bwise-hardware/hardware-models/${id}`)
}

export function deleteHardware(id) {
    return api.delete(`/bwise-hardware/hardware/${id}`)
}

export function EditHardwareModel(
    id,
    patchVariable) {
    return api.put(`/bwise-hardware/hardware-models/${id}/`, patchVariable)
}

export function EditHardware(
    id,
    patchVariable) {
    return api.put(`/bwise-hardware/hardware/${id}/`, patchVariable)
}

export function addLicenseType(
    name,
    description,
    durationValue,
    durationUnit,
    types,
    config,
) {
    var duration = null

    var slug_name = slugify(name)


    if (durationUnit !== "lifetime") {
        const durationToSecondsMap = {
            days: 86400,
            months: 2629800,
            years: 31557600
        }
        var totalSeconds = durationValue * durationToSecondsMap[durationUnit]

        duration = {
            seconds: totalSeconds
        }
    }

    if (!types.includes("historian")) {
        config["historian"] = {
            max_tags: 0
        }
    }

    if (!types.includes("pid")) {
        config["pid"] = {
            max_control_loops: 0
        }
    }

    return api.post("/bwise-license/license-types/", {
        name,
        slug_name,
        description,
        duration,
        types,
        config
    })
}

export function addLicense(
    company,
    description,
    license_type,
    is_server_type,
) {
    return api.post("/bwise-license/licenses/", {
        company,
        description,
        license_type,
        is_server_type,
    })
}

export function editLicense(id, payload) {
    return api.put(`/bwise-license/licenses/${id}/`, payload)
}

export function deleteLicense(id) {
    return api.delete(`/bwise-license/licenses/${id}/`)
}

export function HardwareModelFilterRequest(
    manufacturer, cpu_arch) {
        console.log(manufacturer,cpu_arch)
    return api.get(`/bwise-hardware/hardware-models/?manufacturer=${manufacturer}&cpu_arch=${cpu_arch}`)
}

export function HardwareFilterRequest(company, hardware_model) {
    return api.get(`/bwise-hardware/hardware/?company=${company}&expand=company&hardware_model=${hardware_model}&expand=hardware_model`)
}

export function GetLicenses() {
    return api.get(`/bwise-license/licenses/?expand=license_type`)
}

export async function LinkLicense(data) {
    try{
        const res = await api.post(`/bwise-license/license-links/`, data)
        console.log(res)
        return Promise.resolve(res)
    } catch(err) {
        console.log("erro")
        console.log(err.response)
        return Promise.reject(err)
    }


}

export function DownloadLicense(LinkId) {
    return api.get(`license-links/${LinkId}/license-file-download/`)
}

export function deleteLinkedLicense(id) {
    return api.delete(`/bwise-license/license-links/${id}/`)
}

export function DownloadLicenseFile(id) {
    return api.get(`/bwise-license/license-links/${id}/license-file-download/`, {
        responseType: "arraybuffer"
    })
}

export function GetLicense(id) {
    return api.get(`/bwise-license/licenses/${id}/?expand=company&expand=license_type`)
}

export function GetHardwareByHardwareKey(hardware_key) {
    return api.get(`/bwise-hardware/hardware/hardware-key/${hardware_key}/`)
}
